// extracted by mini-css-extract-plugin
module.exports = {"item":"i_ba","label":"i_bb","value":"i_bc","total":"i_bd"};